// extracted by mini-css-extract-plugin
export default {"container":"_1YQPnuwtEIIqJ87kcE3ql6"};